import { useDatasetData } from '../hooks/useDatasetData';

export const getDataFromDatasetRequest = async (
  fetchFn: () => ReturnType<
    | ReturnType<typeof useDatasetData>['fetch']
    | ReturnType<typeof useDatasetData>['detailedFetch']
  >,
  returnFirst = false
) => {
  const response = await fetchFn();

  if (returnFirst) {
    return response?.data?.[0];
  }

  return response?.data;
};
